import { differenceInWeeks } from 'date-fns';

export const getRevalidateTime = (date) => {
  const shortTimeout = Number(process.env.REVALIDATION_TIMEOUT_SHORT) || 1;
  const mediumTimeout = Number(process.env.REVALIDATION_TIMEOUT_MEDIUM) || 1;
  const longTimeout = Number(process.env.REVALIDATION_TIMEOUT_LONG) || 1;

  const publishDate = new Date(date);
  const todaysDate = new Date(Date.now());
  const weeksDifference = Math.abs(differenceInWeeks(todaysDate, publishDate));

  if (weeksDifference < 1) {
    return shortTimeout;
  }

  if (weeksDifference < 24) {
    return mediumTimeout;
  }

  return longTimeout;
};

export default { getRevalidateTime };
